import React, { useState } from 'react';
import styles from './InputDropdown.module.scss';
import { InputContainer } from '../InputContainer/InputContainer';
//translations
import { tr } from '../../../../utils/translations/translator';
import { useTranslation } from 'react-i18next';
import { OutsideAlerter } from '../OutsideAlerter/OutsideAlerter';
import classnames from 'classnames';
import { Validity } from '../../interfaces/tip/Validations';
import { InputHeader } from '../InputHeader/InputHeader';
import { isUnique } from './utils';
interface InputDropdownProps {
  label: string;
  options?: any[];
  featuredOptions?: any[];
  handleChange: (option: any) => void;
  value?: any;
  DropdownItem: React.FC<any>;
  placeholder?: string;
  openUpwards?: boolean;
  DropdownTitle?: string;
  validity?: Validity | false;
  type: 'sport' | 'bookie';
}

export const InputDropdown: React.FC<InputDropdownProps> = ({
  label,
  options,
  featuredOptions,
  handleChange,
  value,
  DropdownItem,
  placeholder = ' ',
  openUpwards = false,
  DropdownTitle,
  validity,
  type,
}) => {
  const { t } = useTranslation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const cx = classnames.bind(styles);
  const handleSelect = (option: any) => {
    handleChange(option);
    setIsDropdownOpen(false);
  };
  const renderOptions = (options: any) =>
    options.map((option: any, index: number) => (
      <DropdownItem
        key={option.code || option.id || `option-${index}`}
        option={option}
        onClick={handleSelect}
        value={formatValue(option)}
      />
    ));
  const formatValue = (value: any) => {
    if (type === 'bookie') {
      return value.name;
    }
    return tr(t, value.code);
  };

  const filteredOptions = options
    ? featuredOptions
      ? options.filter((option) => isUnique(option.code, featuredOptions))
      : options
    : [];

  return (
    <>
      <InputContainer label={label} isDropdown validity={validity}>
        <div
          onClick={() => {
            setIsDropdownOpen(!isDropdownOpen);
          }}
          className={styles.InputDropdown}
        >
          <p>
            {value ? (
              formatValue(value)
            ) : (
              <span className={styles.placeholder}>{placeholder}</span>
            )}
          </p>
          {isDropdownOpen && (
            <OutsideAlerter
              onBlur={() => {
                setIsDropdownOpen(false);
              }}
            >
              <div
                className={cx(
                  styles.Dropdown,
                  openUpwards ? styles.openUpwards : styles.unset,
                )}
              >
                {DropdownTitle && (
                  <div className={styles.DropdownHeader}>
                    <label>{DropdownTitle}</label>
                    <button onClick={() => setIsDropdownOpen(false)}>OK</button>
                  </div>
                )}
                {featuredOptions && (
                  <>
                    <div className={styles.DropdownTitle}>
                      <InputHeader title={tr(t, 'most-used-by-you')} />
                    </div>
                    {renderOptions(featuredOptions)}
                  </>
                )}
                <div className={styles.DropdownTitle}>
                  <InputHeader title={tr(t, 'most-used-by-others')} />
                </div>
                {renderOptions(filteredOptions)}
              </div>
            </OutsideAlerter>
          )}
        </div>
      </InputContainer>
    </>
  );
};
